import { createSlice } from "@reduxjs/toolkit";
import { deleteToken, getToken, mainAuthName } from "../../utils/tokens";

const initialState = {
  otp: undefined,
  user_found: false,
  mobile:
    typeof window !== "undefined" ? localStorage.getItem("mobile") || "" : "",
  user: getToken(mainAuthName) || undefined,
  organization: 1,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUserOtp: (state, action) => {
      state.otp = action.payload;
    },
    setUserFound: (state, action) => {
      state.user_found = action.payload;
    },
    deleteUser: (state) => {
      state.user = undefined;
      deleteToken();
      window.open("/", "_self")
    },
  },
});

export default authSlice;
export const { setUserOtp, setUserFound, setUser, deleteUser } =
  authSlice.actions;
